export const FAQ_LOCAL_ID_PREFIX = "local-";
export const FAQ_MAX_QUESTION_LENGTH = 150;
export const FAQ_MAX_ANSWER_LENGTH = 600;

const DEFAULT_MAX_FAQS = 30;
const FAQ_40_MAX_FAQS = 40;
const FAQ_50_MAX_FAQS = 50;

const RITAS_OF_HOWELL = "agent_c566392e711c3e2830373a3aee";
const RITAS_OF_LAKEWOOD = "agent_34807215bccf3ef30e0307800d";
const AGENTS_WITH_40_FAQ_LIMIT = new Set<string>([
  RITAS_OF_HOWELL,
  RITAS_OF_LAKEWOOD,
]);

const ENOS_PIZZA_TAVERN_COPPELL = "agent_6013eb51f2b2196a8b1186ae8a";
const AGENTS_WITH_50_FAQ_LIMIT = new Set<string>([ENOS_PIZZA_TAVERN_COPPELL]);

export const getMaxFaqs = (agentId?: string | null) => {
  if (agentId && AGENTS_WITH_40_FAQ_LIMIT.has(agentId)) {
    return FAQ_40_MAX_FAQS;
  }

  if (agentId && AGENTS_WITH_50_FAQ_LIMIT.has(agentId)) {
    return FAQ_50_MAX_FAQS;
  }

  return DEFAULT_MAX_FAQS;
};
